/*
 * This component should never be changed manually
 * Please use `yarn generate-svg "SVG FILENAME"`
 */
import { ReactComponent as Icon } from '../assets/Catalog.svg'
import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconCatalog = ({ ...props }: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Icon />
    </IconComponentStyled>
  )
}

IconCatalog.displayName = 'IconCatalog'
